import { defineStore } from 'pinia'
import { ref } from 'vue'
import api from '@/axios/api'

import { type DateTime } from 'luxon'

import { UTC_TIMEZONE, getDateObjFromIso } from '@scripts/entities/dates'

export const useGlobalStore = defineStore('useGlobalStore', () => {
  const appWidth = ref(0)
  const isClickedMainTemplateDisabledScreen = ref(false)
  const nowUTCDateObj = ref<DateTime | null>(null)

  const setClickedMainTemplateDisabledScreen = (status: boolean = true) => {
    isClickedMainTemplateDisabledScreen.value = status
  }

  const setAppWidth = (width: number) => {
    appWidth.value = width
  }

  const getNowUTCDate = async () => {
    await api.get('/common', { timeout: 3000 })
      .then(response => {
        nowUTCDateObj.value = getDateObjFromIso(response.data.currentTimeUTC, UTC_TIMEZONE)
      })
      .catch((error) => {
        console.error(error)
      })
  }

  return {
    appWidth,
    isClickedMainTemplateDisabledScreen,
    nowUTCDateObj,
    setAppWidth,
    getNowUTCDate,
    setClickedMainTemplateDisabledScreen
  }
})
